import { MoreBar } from '@revolut-internal/ui-kit'

import { API_URL } from 'lib/shared/consts'
import { auth } from 'lib/auth'

const POPUP_WIDTH = 550
const POPUP_HEIGHT = 600

const getPopupX = () => window.screen.width / 2 - POPUP_WIDTH / 2

const getPopupFeatures = () =>
  `popup,width=${POPUP_WIDTH},height=${POPUP_HEIGHT},screenX=${getPopupX()},screenY=100`

const INBOX_AUTH_PATH = `${API_URL}/inbox-auth/start`

// Todo add permission check when https://revolut.atlassian.net/browse/PCM-5440 is done
export const AddInbox = () => {
  return (
    <MoreBar.Action
      useIcon="Plus"
      onClick={() => {
        auth.init().then(user => {
          if (user) {
            window.open(INBOX_AUTH_PATH, '_blank', getPopupFeatures())
          }
        })
      }}
    >
      Add
    </MoreBar.Action>
  )
}
